module.exports = __webpack_public_path__ + "2f99fb3a8fa012dd792b104a66ca170b.MP3";